import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {variablesMaintenance} from '/redux/selector/remoteConfig.selector';

import MaintenancePageProviderComponent from './MaintenancePageProvider';

const MaintenancePageProviderConnected = connect(
  createStructuredSelector({
    maintenance: variablesMaintenance,
  }),
)(MaintenancePageProviderComponent);

export {MaintenancePageProviderConnected as MaintenancePageProvider};
